import { isUndefined } from 'lodash-es';

import { CONFIGURATOR_PACKAGE_OFF_LEVEL, CONFIGURATOR_PACKAGE_OFF_LEVEL_DETAILS, CURRENCY_SYMBOLS } from '../constants';
import {
  ConfiguratorContextEngagementPackageLevelDetails,
  ConfiguratorContextTrafficPackageDetails,
  ConfiguratorEngagementPackage,
  ConfiguratorEngagementPackageLevel,
  ConfiguratorTrafficPackage,
  Maybe,
} from '../types';

export function getEngagementPackage(
  packages: ConfiguratorEngagementPackage[],
  packageId?: string,
): Maybe<ConfiguratorEngagementPackage> {
  return !isUndefined(packageId)
    ? packages.find((engagementPack) => engagementPack.id === packageId)
    : packages.length
      ? packages[0]
      : undefined;
}

export function getEngagementPackageLevels(
  levels: ConfiguratorEngagementPackageLevel[],
): ConfiguratorEngagementPackageLevel[] {
  return [CONFIGURATOR_PACKAGE_OFF_LEVEL, ...levels];
}

export function getEngagementPackageLevelDetails(
  levels: ConfiguratorEngagementPackageLevel[],
  levelId?: string | false,
): Maybe<ConfiguratorContextEngagementPackageLevelDetails> {
  if (isUndefined(levelId)) {
    return CONFIGURATOR_PACKAGE_OFF_LEVEL_DETAILS;
  }

  const level = levels.find((level) => level.id === levelId);

  if (isUndefined(level)) {
    return CONFIGURATOR_PACKAGE_OFF_LEVEL_DETAILS;
  }

  const { currency, discount, name, price } = level;

  const currencySymbol = CURRENCY_SYMBOLS[currency] ?? currency;

  const titleText = `${name['en']} Benefits`; // TODO: temporary translation

  const priceText = `${name['en']}: ${currencySymbol}${price} / mo`; // TODO: temporary translation

  const discountText = discount > 0 ? `${currencySymbol}${discount} off for a limited time only` : '';

  return { titleText, priceText, discountText, benefits: level.benefits, benefitsActive: level.benefits.length > 0 };
}

export function getEngagementDefaultSelection(
  packages: ConfiguratorEngagementPackage[],
): Record<string, string | false> {
  const selection: Record<string, string | false> = {};

  packages.forEach((engagementPack) => {
    selection[engagementPack.id] = false;
  });

  return selection;
}

export function getTrafficPackage(
  packages: ConfiguratorTrafficPackage[],
  packageId?: string,
): Maybe<ConfiguratorTrafficPackage> {
  return !isUndefined(packageId)
    ? packages.find((trafficPackage) => trafficPackage.id === packageId)
    : packages.length
      ? packages[0]
      : undefined;
}

export function getTrafficPackageDetails(pack: ConfiguratorTrafficPackage): ConfiguratorContextTrafficPackageDetails {
  const { currency, discount, price } = pack;

  const currencySymbol = CURRENCY_SYMBOLS[currency] ?? currency;

  const priceText = `${currencySymbol}${price} / mo`;

  const discountText = discount > 0 ? `${currencySymbol}${discount} off for a limited time only` : '';

  return { priceText, discountText };
}
